<div class="custom-section card workflow-page" [class.workflow-create-mode]="isCreateScreen">
  <app-success-toast *ngIf="toastService.showToast"></app-success-toast>

  <div class="section-header custom-header workflow-header">
    <div class="page-title">
      <h1 class="section-title">{{ isCreateScreen ? 'Create Workflow' : 'Platform Workflow Templates' }}</h1>
    </div>
    <div *ngIf="!isCreateScreen" class="workflow-header-actions">
      <button
        class="btn-outline workflow-action"
        type="button"
        [routerLink]="['/settings/workflows/exceptions']">
        Needs Assignment
      </button>
      <button
        class="btn-fill workflow-action"
        type="button"
        [routerLink]="['/settings/workflows/create-workflow']">
        Create New Template
      </button>
    </div>
  </div>

  <div class="workflow-list-section" *ngIf="!isCreateScreen" (click)="closeWorkflowTemplateMenu()">
    <div class="workflow-list-toolbar">
      <div class="status-filter" role="group" aria-label="Filter workflow templates by status">
        <button
          *ngFor="let filter of statusFilters"
          type="button"
          class="status-filter-button"
          [class.active]="selectedStatusFilter === filter"
          (click)="selectStatusFilter(filter); $event.stopPropagation()">
          {{ filter }}
        </button>
      </div>
    </div>

    <div class="workflow-list-message" *ngIf="isLoadingTemplates">Loading workflow templates...</div>
    <div class="workflow-list-message error" *ngIf="!isLoadingTemplates && templateListError">
      {{ templateListError }}
    </div>
    <div class="workflow-list-message" *ngIf="!isLoadingTemplates && !templateListError && !workflowTemplates.length">
      No workflow templates found.
    </div>

    <div
      class="workflow-table-scroll"
      (scroll)="closeWorkflowTemplateMenu()"
      *ngIf="!isLoadingTemplates && !templateListError && workflowTemplates.length">
      <table class="custom-table workflow-custom-table">
        <thead>
          <tr>
            <th>Template Name</th>
            <th>Type</th>
            <th>Stages</th>
            <th>Status</th>
            <th>Last Modified</th>
            <th>
              <img src="../../assets/dotted-menu.svg" alt="menu icon" />
            </th>
          </tr>
        </thead>
        <tbody *ngFor="let template of workflowTemplates; trackBy: trackTemplateById">
          <tr>
            <td>
              <button class="template-name-button" type="button" (click)="continueBuilding(template)">
                {{ template.name }}
              </button>
              <p class="template-description" *ngIf="template.description">
                {{ template.description }}
              </p>
            </td>
            <td>{{ tierLabel(template.tier) }}</td>
            <td>{{ template.stageCount }}</td>
            <td>
              <span class="workflow-status-pill" [ngClass]="workflowStatusClass(template.status)">
                {{ formatWorkflowStatus(template.status) }}
              </span>
            </td>
            <td>
              <div class="workflow-modified">
                <span class="workflow-modified__date">{{ formatDate(template.updatedAt) }}</span>
                <span class="workflow-modified__time" *ngIf="formatTime(template.updatedAt)">
                  {{ formatTime(template.updatedAt) }}
                </span>
              </div>
            </td>
            <td>
              <img
                src="../../assets/dotted-menu.svg"
                alt="menu icon"
                class="workflow-menu-trigger"
                (click)="toggleWorkflowTemplateMenu(template.workflowTemplateId, $event)" />

              <div
                class="custom-table__menu workflow-table-menu"
                *ngIf="activeWorkflowTemplateMenuId === template.workflowTemplateId"
                [style.top.px]="workflowTemplateMenuPosition.top"
                [style.left.px]="workflowTemplateMenuPosition.left"
                (click)="$event.stopPropagation()">
                <div>{{ template.name }}</div>

                <a
                  *ngIf="template.status === 'DRAFT'"
                  (click)="continueBuilding(template)">
                  <img src="../../assets/edit-pencil.svg" alt="menu icon" />
                  <span>Continue Building</span>
                </a>
                <a
                  *ngIf="template.status !== 'DRAFT'"
                  (click)="openPublishedTemplate(template)">
                  <img src="../../assets/settings.svg" alt="menu icon" />
                  <span>View Details</span>
                </a>
                <a
                  *ngIf="template.status === 'DRAFT'"
                  class="custom-table__menu-option"
                  (click)="openPublishFlow(template)">
                  <img src="../../assets/check-mark.svg" alt="menu icon" />
                  <span>Publish</span>
                </a>

                <div class="underline" *ngIf="canMarkInactive(template)"></div>
                <div
                  *ngIf="canMarkInactive(template)"
                  (click)="openDeactivateFlow(template)">
                  <img src="../../assets/delete.svg" alt="menu icon" />
                  <span>Mark Inactive</span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div
    class="workflow-confirm-backdrop"
    *ngIf="isPublishConfirmOpen && templatePendingPublish as template"
    (click)="cancelPublishFlow()">
    <section
      class="workflow-confirm-card"
      role="dialog"
      aria-modal="true"
      aria-labelledby="publishWorkflowTitle"
      (click)="$event.stopPropagation()">
      <button
        class="workflow-confirm-close"
        type="button"
        aria-label="Close"
        [disabled]="isPublishingTemplate"
        (click)="cancelPublishFlow()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>

      <h2 id="publishWorkflowTitle">Publish workflow template?</h2>
      <p>
        This draft will be checked before publishing. If validation is needed, you will be taken to the builder to review it.
      </p>

      <div class="workflow-confirm-summary">
        <strong>{{ template.name }}</strong>
        <span>{{ template.sku }} - {{ formatWorkflowStatus(template.status) }}</span>
      </div>

      <div class="workflow-confirm-actions">
        <button
          class="workflow-confirm-secondary-button"
          type="button"
          [disabled]="isPublishingTemplate"
          (click)="cancelPublishFlow()">
          Cancel
        </button>
        <button
          class="workflow-confirm-primary-button"
          type="button"
          [disabled]="isPublishingTemplate"
          (click)="confirmPublishTemplate()">
          {{ isPublishingTemplate ? 'Publishing...' : 'Publish' }}
        </button>
      </div>
    </section>
  </div>

  <div
    class="workflow-confirm-backdrop"
    *ngIf="isDeactivateConfirmOpen && templatePendingDeactivation as template"
    (click)="cancelDeactivateFlow()">
    <section
      class="workflow-confirm-card"
      role="dialog"
      aria-modal="true"
      aria-labelledby="deactivateWorkflowTitle"
      (click)="$event.stopPropagation()">
      <button
        class="workflow-confirm-close"
        type="button"
        aria-label="Close"
        [disabled]="isDeactivatingTemplate"
        (click)="cancelDeactivateFlow()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>

      <h2 id="deactivateWorkflowTitle">Mark template inactive?</h2>
      <p>
        This published workflow template will move to Inactive and will no longer be available for new use.
      </p>

      <div class="workflow-confirm-summary">
        <strong>{{ template.name }}</strong>
        <span>{{ template.sku }} - {{ formatWorkflowStatus(template.status) }}</span>
      </div>

      <div class="workflow-confirm-actions">
        <button
          class="workflow-confirm-secondary-button"
          type="button"
          [disabled]="isDeactivatingTemplate"
          (click)="cancelDeactivateFlow()">
          Cancel
        </button>
        <button
          class="workflow-confirm-primary-button"
          type="button"
          [disabled]="isDeactivatingTemplate"
          (click)="confirmDeactivateTemplate()">
          {{ isDeactivatingTemplate ? 'Marking inactive...' : 'Mark Inactive' }}
        </button>
      </div>
    </section>
  </div>

  <div class="workflow-modal-backdrop" *ngIf="isCreateScreen" (click)="closeCreateModal()">
    <form
      class="workflow-modal-card"
      (submit)="$event.preventDefault(); $event.stopPropagation(); startBuilding()"
      (click)="$event.stopPropagation()"
      novalidate>
      <button class="workflow-modal-close" type="button" aria-label="Go back" (click)="closeCreateModal()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
      </button>

      <div class="workflow-form-content">
        <div class="modal-brand">
          <div class="modal-logo">
            <img src="../../../../assets/workflow.svg" alt="" />
          </div>
          <!-- <span>SmartFlow&trade;</span> -->
        </div>

        <h2>Create a new template</h2>
        <p class="modal-subtitle">Configure routing, fields, and approvers without code.</p>

        <p class="field-error name-error" *ngIf="showNameError">{{ nameErrorMessage }}</p>
        <label class="workflow-label" for="workflowName">
          Template name <span>*</span>
        </label>
        <input
          id="workflowName"
          name="workflowName"
          type="text"
          class="workflow-input"
          placeholder="Enter template name"
          [class.input-error]="showNameError"
          [ngModel]="draftName"
          (ngModelChange)="onNameInput($event)"
          (blur)="refreshSkuSuggestion()"
          [disabled]="isSaving"
          autofocus />
        <div class="character-counter" [class.counter-error]="draftName.length > workflowNameLimit">
          {{ draftName.length }}/{{ workflowNameLimit }}
        </div>

        <div class="sku-reference-row">
          <div class="workflow-field">
            <label class="workflow-label" for="workflowSku">SKU</label>
            <input
              id="workflowSku"
              name="workflowSku"
              type="text"
              class="workflow-input"
              placeholder="Auto-suggested from name"
              [ngModel]="draftSku"
              (ngModelChange)="onSkuInput($event)"
              (blur)="refreshSkuSuggestion()"
              [disabled]="isSaving" />
          </div>

          <div class="workflow-field">
            <label class="workflow-label" for="workflowReferenceCode">Reference code</label>
            <input
              id="workflowReferenceCode"
              name="workflowReferenceCode"
              type="text"
              class="workflow-input"
              [ngModel]="draftReferenceCode"
              disabled />
          </div>
        </div>

        <p class="field-error description-error" *ngIf="showDescriptionError">{{ descriptionErrorMessage }}</p>
        <label class="workflow-label" for="workflowDescription">Description</label>
        <textarea
          id="workflowDescription"
          name="workflowDescription"
          class="workflow-input workflow-textarea"
          placeholder="Add a short description of what this workflow is used for"
          [class.input-error]="showDescriptionError"
          [ngModel]="draftDescription"
          (ngModelChange)="onDescriptionInput($event)"
          [disabled]="isSaving"></textarea>
        <div class="character-counter" [class.counter-error]="draftDescription.length > workflowDescriptionLimit">
          {{ draftDescription.length }}/{{ workflowDescriptionLimit }}
        </div>

        <label class="workflow-label stage-label">How many stages does this workflow have?</label>
        <div class="stage-segment" role="group" aria-label="Workflow stage count">
          <button
            *ngFor="let stageCount of stageCounts"
            type="button"
            class="segment-button"
            [class.active]="selectedStageCount === stageCount"
            [disabled]="isSaving"
            (click)="selectStageCount(stageCount)">
            {{ stageCount }}
          </button>
        </div>
        <p class="stage-hint">{{ stageHint }}</p>

        <label class="workflow-label tier-label">Workflow type</label>
        <div class="tier-options">
          <label
            *ngFor="let tier of tiers"
            class="tier-card"
            [class.selected]="selectedTier === tier.value">
            <input
              type="radio"
              name="workflowTier"
              [value]="tier.value"
              [checked]="selectedTier === tier.value"
              [disabled]="isSaving"
              (change)="selectTier(tier.value)" />
            <span>
              <strong>{{ tierLabel(tier.value) }}</strong>
              <small>{{ tier.description }}</small>
            </span>
          </label>
        </div>

        <div class="modal-actions">
          <button class="start-building-button" type="submit" [disabled]="isSaving">
            {{ isSaving ? 'Saving...' : 'Start Building' }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
